import { CardHeader } from '@amzn/meridian/card';
import { localize } from './localize';

export default localize(CardHeader, ['children']);
